import { type CSSProperties, type ReactNode } from "react";
import { Select } from "antd";
import { CloseIcon, PlusIconBlack } from "@/shared/assets/svg/icons";

interface FilterSelectProps {
  filterLabel: string;
  getFilterStyle: (filterLabel: string) => CSSProperties;
  getFilterIcon: (
    filterLabel: string,
    clearIcon: ReactNode,
    plusIcon: ReactNode,
  ) => ReactNode;
  getOptionsForFilter: (
    filterLabel: string,
  ) => { label: string; value: string }[];
  getFilterValue: (filterLabel: string) => string | null;
  handleFilterChange: (filterLabel: string, value: string) => void;
  isFilterActive: boolean;
}

export function FilterSelect({
  filterLabel,
  getFilterStyle,
  getFilterIcon,
  getOptionsForFilter,
  getFilterValue,
  handleFilterChange,
  isFilterActive,
}: FilterSelectProps) {
  const style = {
    width: "16px",
    height: "16px",
    fontSize: "16px",
  };
  return (
    <Select
      variant="borderless"
      style={{
        ...getFilterStyle(filterLabel),
        minWidth: "150px",
        backgroundColor: isFilterActive ? "#FFFFFF" : "transparent",
      }}
      suffixIcon={getFilterIcon(
        filterLabel,
        <CloseIcon style={style} />,
        <PlusIconBlack style={style} />,
      )}
      allowClear={{
        clearIcon: <CloseIcon style={style} />,
      }}
      showSearch
      placeholder={filterLabel}
      value={getFilterValue(filterLabel) || undefined}
      options={getOptionsForFilter(filterLabel)}
      onChange={(value) => handleFilterChange(filterLabel, value)}
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
    />
  );
}
